import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Footer from '../components/Footer';
import '../styles/home.css';
import { useContagemTempo } from '../hooks/useContagemTempo'; // Importar o hook

const Home = () => {
  const navigate = useNavigate();
  
  // Usar o hook de contagem de tempo
  const { pararTodasContagens } = useContagemTempo();
  
  // Estados para o usuário
  const [username, setUsername] = useState('usuário');
  const [carregandoNome, setCarregandoNome] = useState(true);
  
  // Recuperar o estado da animação do localStorage ou começar do 0
  const [animacaoAtual, setAnimacaoAtual] = useState(() => {
    const savedAnimacao = localStorage.getItem('animacaoAtual');
    return savedAnimacao ? parseInt(savedAnimacao, 10) : 0;
  });

  // Array com as URLs das animações
  const animacoes = [
    // 'https://lottie.host/embed/5b7c96e0-b6d2-4595-af0c-2f3db5ff6874/cpfR1t5Rfk.lottie',
    'https://lottie.host/embed/46816294-71b3-49df-8ef7-5d095e5fc96b/1dxB804haz.json',
    'https://lottie.host/embed/45af3a4c-75e6-42ba-b74b-c9a98e1639a3/r2rPa6bgO4.json',
    // 'https://lottie.host/embed/3fec94f8-736a-45c0-ae35-03e7a8a360cc/9TCXE1QxHX.json'
  ];
// https://lottie.host/embed/46816294-71b3-49df-8ef7-5d095e5fc96b/1dxB804haz.json
  // Função para buscar dados do usuário
  const buscarDadosUsuario = async () => {
    try {
      const accessToken = localStorage.getItem('access');
      
      if (!accessToken) {
        setCarregandoNome(false);
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE}/api/verificar-grupo/`,
        {
          headers: { Authorization: `Bearer ${accessToken}` }
        }
      );

      if (response.data.success) {
        // Priorizar a coluna 'name', depois first_name, depois username
        const nomeUsuario = response.data.name || 
                           response.data.first_name || 
                           response.data.usuario || 
                           'usuário';
        
        setUsername(nomeUsuario);
      } else {
        setUsername('usuário');
      }
    } catch (error) {
      console.error('Erro ao buscar dados do usuário:', error);
      setUsername('usuário');
    } finally {
      setCarregandoNome(false);
    }
  };

  // Carregar dados do usuário ao montar o componente
  useEffect(() => {
    buscarDadosUsuario();
  }, []);

  // Fundo cinza da marca em toda a página (inclusive frestas fora do .content);
  // restaura o fundo original ao sair da Home
  useEffect(() => {
    const fundoAnterior = document.body.style.backgroundColor;
    document.body.style.backgroundColor = '#f9f9fb';
    return () => {
      document.body.style.backgroundColor = fundoAnterior;
    };
  }, []);

  // useEffect para rotação das animações
  useEffect(() => {
    const intervalAnimacao = setInterval(() => {
      setAnimacaoAtual(prevAnimacao => {
        const novaAnimacao = (prevAnimacao + 1) % animacoes.length;
        // Salvar no localStorage sempre que mudar
        localStorage.setItem('animacaoAtual', novaAnimacao.toString());
        return novaAnimacao;
      });
    }, 9000); // 4 segundos

    // Cleanup do interval quando o componente desmontar
    return () => clearInterval(intervalAnimacao);
  }, [animacoes.length]);

  // useEffect para salvar o estado inicial no localStorage
  useEffect(() => {
    localStorage.setItem('animacaoAtual', animacaoAtual.toString());
  }, [animacaoAtual]);

  // Função para lidar com logout e parar contagens
  const handleLogout = async () => {
    try {
      // Parar todas as contagens ativas antes de fazer logout
      await pararTodasContagens();
      
      // Pequeno delay para garantir que a requisição foi processada
      setTimeout(() => {
        navigate('/logout');
      }, 500);
    } catch (error) {
      console.error('Erro ao parar contagens durante logout:', error);
      // Mesmo com erro, continuar com o logout
      navigate('/logout');
    }
  };

  return (
    <div className="content home-fmp d-flex flex-column justify-content-start align-items-center">
      <i
        className="fa fa-sign-out-alt logout-icon"
        onClick={handleLogout}
        title="Sair"
        style={{
          position: 'absolute',
          top: '28px',
          right: '36px',
          fontSize: '22px',
          color: '#dc3545',
          cursor: 'pointer'
        }}
      ></i>

      {/* Hero em duas colunas: texto à esquerda, animação à direita.
          O zoom que iguala ao mockup fica isolado aqui — o Footer abaixo
          continua no tamanho normal do site. */}
      <div className="home-zoom">
      <div className="home-hero-grid">
        <div className="home-hero">
          <span className="home-eyebrow">Comece Hub</span>
          <h1>
            Olá,{' '}
            <span className="home-nome">
              {carregandoNome ? (
                <i className="fas fa-spinner fa-spin"></i>
              ) : (
                username
              )}
            </span>
            .<br />
            Por onde vamos começar hoje?
          </h1>
          <p className="home-lead">
            Sua central de{' '}
            <span className="home-lead-destaque">inteligência em dados</span>.
          </p>

          {/* Novidade — chip ciano da marca */}
          <div className="home-novidade">
            <strong>Novidade:</strong> Estamos com uma nova aparência!
          </div>

          {/* Botão para continuar — CTA dourado da marca */}
          <button
            className="home-cta"
            onClick={() => navigate('/relatorio-fiscal')}
          >
            Continuar para o menu principal
            <i className="fas fa-arrow-right home-cta-arrow"></i>
          </button>
        </div>

        {/* Animação Rotativa (mantida) — entra deslizando do canto da tela a cada troca */}
        <div className="home-anim d-flex justify-content-center align-items-center">
          <div className="home-anim-enter" key={animacaoAtual}>
            <iframe
              className="animation3"
              src={animacoes[animacaoAtual]}
              title="Lottie Animation"
              style={{
                width: '300px',
                height: '255px',
                border: 'none',
                margin: 0,
                mixBlendMode: 'multiply', // funde o fundo branco do iframe com o cinza da página
              }}
            />
          </div>
        </div>
      </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;